<a *ngIf="(menuWrapperService.orderIdCookieExists$ | async)"
   class="btn btn-link text-uppercase font-secondary text-nowrap"
   [ngClass]="{'fw-600': fontWeight, 'btn-undecorated': btnUndecorated, 'btn-header': !btnUndecorated, 'rendered-in-minified': minifiedHeader}"
   (click)="handleTrackerLinkClick()"
   target="_blank"
   tabindex="0"
   role="link"
   tabindex="0"
   [attr.aria-label]="('component.order_box.track' | translate) + ' ' + ('route.new_tab.opens_new_tab' | translate)">
   {{'component.order_box.track' | translate}}
</a>
